// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dlt-form-container {
    background-color: #f9f9f9; 
    border: 1px solid #ddd;
    border-radius: 8px; 
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    padding: 25px 20px;
    margin: 20px auto; 
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center; 
    justify-content: center; 
}

.dlt-form-container input {
    width: 100%;
    max-width: 400px; 
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-bottom: 10px;
}

.dlt-info-text {
    font-size: 14px;
    color: #555;
    margin-bottom: 16px;
    text-align: left;
}

.dlt-info-text strong {
    font-weight: bold;
    font-size: 20px;
    color: #333;
}

.dlt-form-submit {
    color: #fff;
    background-color: #44a67e;
    border: 1px solid #44a67e;
    padding: 10px 20px;
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 10px;
    display: flex;
}

.dlt-form-submit:hover {
    background-color: #218838;
}


/* DLT Chain table style */
.dlt-chain-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }
  
  .dlt-chain-table th,
  .dlt-chain-table td {
    text-align: left;
    padding: 10px;
    border: 1px solid #ddd;
    color: #373435;
  }
  
  .dlt-chain-table th {
    background-color: #f2f2f2;
    font-weight: bold;
    color: #373435;
    text-transform: uppercase;
    text-align: left;
  }
  
  .dlt-chain-table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .dlt-chain-table tr:hover {
    background-color: #f1f1f1;
  }

/* Response Message */
.dltChainResponse {
    background-color: #28a745;
    color: #fff;
    border-radius: 5px;
    display: none; 
    margin: 20px auto; 
}

.dltChainResponse.visible {
    display: block;
}

.dltChainResponse p {
    color: #fff;
    margin-top: 10px;
    padding: 10px;
    text-align: left;
}

.wrap-dlt-chain {
  margin: 0 40px;
}`, "",{"version":3,"sources":["webpack://./src/components/DltChainRegistration/DltChainRegistration.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA,0BAA0B;AAC1B;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;AAEF,qBAAqB;AACrB;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".dlt-form-container {\r\n    background-color: #f9f9f9; \r\n    border: 1px solid #ddd;\r\n    border-radius: 8px; \r\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\r\n    padding: 25px 20px;\r\n    margin: 20px auto; \r\n    background-color: #fff;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center; \r\n    justify-content: center; \r\n}\r\n\r\n.dlt-form-container input {\r\n    width: 100%;\r\n    max-width: 400px; \r\n    padding: 10px;\r\n    font-size: 16px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.dlt-info-text {\r\n    font-size: 14px;\r\n    color: #555;\r\n    margin-bottom: 16px;\r\n    text-align: left;\r\n}\r\n\r\n.dlt-info-text strong {\r\n    font-weight: bold;\r\n    font-size: 20px;\r\n    color: #333;\r\n}\r\n\r\n.dlt-form-submit {\r\n    color: #fff;\r\n    background-color: #44a67e;\r\n    border: 1px solid #44a67e;\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-top: 10px;\r\n    display: flex;\r\n}\r\n\r\n.dlt-form-submit:hover {\r\n    background-color: #218838;\r\n}\r\n\r\n\r\n/* DLT Chain table style */\r\n.dlt-chain-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    text-align: left;\r\n  }\r\n  \r\n  .dlt-chain-table th,\r\n  .dlt-chain-table td {\r\n    text-align: left;\r\n    padding: 10px;\r\n    border: 1px solid #ddd;\r\n    color: #373435;\r\n  }\r\n  \r\n  .dlt-chain-table th {\r\n    background-color: #f2f2f2;\r\n    font-weight: bold;\r\n    color: #373435;\r\n    text-transform: uppercase;\r\n    text-align: left;\r\n  }\r\n  \r\n  .dlt-chain-table tr:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .dlt-chain-table tr:hover {\r\n    background-color: #f1f1f1;\r\n  }\r\n\r\n/* Response Message */\r\n.dltChainResponse {\r\n    background-color: #28a745;\r\n    color: #fff;\r\n    border-radius: 5px;\r\n    display: none; \r\n    margin: 20px auto; \r\n}\r\n\r\n.dltChainResponse.visible {\r\n    display: block;\r\n}\r\n\r\n.dltChainResponse p {\r\n    color: #fff;\r\n    margin-top: 10px;\r\n    padding: 10px;\r\n    text-align: left;\r\n}\r\n\r\n.wrap-dlt-chain {\r\n  margin: 0 40px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
